// import { Box, Button, Divider, Tooltip } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import PaymentsIcon from "@mui/icons-material/Payments";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import OrderStepper from "./OrderStepper";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import {
//   cancelOrder,
//   fetchOrderById,
//   fetchOrderItemById,
// } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { useNavigate, useParams } from "react-router-dom";

// const ITEMS_PER_PAGE = 5;

// const OrderDetails = () => {
//   const dispatch = useAppDispatch();
//   const { auth, orders } = useAppSelector((store) => store);
//   const { orderItemId, orderId } = useParams();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (orderItemId) {
//       dispatch(
//         fetchOrderItemById({
//           orderItemId: Number(orderItemId),
//           jwt: localStorage.getItem("jwt") || "",
//         })
//       );
//     }

//     if (orderId) {
//       dispatch(
//         fetchOrderById({
//           orderId: Number(orderId),
//           jwt: localStorage.getItem("jwt") || "",
//         })
//       );
//     }
//   }, [auth.jwt, dispatch, orderId, orderItemId]);

//   if (!orders.orders || !orders.orderItem) {
//     return (
//       <div className="h-[80vh] flex justify-center items-center">
//         No order found
//       </div>
//     );
//   }

//   const currentOrder = orders.currentOrder;
//   const orderItem = orders.orderItem;

//   const handleCancelOrder = () => {
//     if (orderId) {
//       dispatch(cancelOrder(orderId));
//     }
//   };

//   const isDelivered = currentOrder?.orderStatus === "DELIVERED";
//   const isShipped = currentOrder?.orderStatus === "SHIPPED";
//   const isShippedOrDelivered = ["SHIPPED", "DELIVERED"].includes(
//     currentOrder?.orderStatus || ""
//   );
//   const isCancelled = currentOrder?.orderStatus === "CANCELLED";

//   const product = orderItem?.product;
//   const sellerName = product?.seller?.businessDetails?.businessName;
//   const address = currentOrder?.shippingAddress;

//   const trackingId =
//     currentOrder?.trackingId || currentOrder?.trackingNumber || "";

//   const itemPrice = orderItem?.sellingPrice || 0;
//   const mrpPrice = orderItem?.mrpPrice || 0;
//   const savedAmount = Math.max(mrpPrice - itemPrice, 0);

//   const orderItems =
//     currentOrder?.orderItems && currentOrder.orderItems.length > 0
//       ? currentOrder.orderItems
//       : [orderItem];

//   const itemTotal = orderItems.reduce(
//     (total: number, item: any) =>
//       total + (item?.sellingPrice || 0) * (item?.quantity || 1),
//     0
//   );

//   const totalAmount =
//     currentOrder?.totalSellingPrice ||
//     currentOrder?.totalMrpPrice ||
//     itemTotal;

//   const placedDate = currentOrder?.orderDate
//     ? new Date(currentOrder.orderDate).toLocaleString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     })
//     : "Not available";

//   const cancelTooltipMessage = isShipped
//     ? "This order cannot be cancelled as it has already been shipped. If you received a damaged or incorrect item, you may request a replacement."
//     : isDelivered
//       ? "This order cannot be cancelled as it has already been delivered."
//       : "";

//   return (
//     <Box className="w-full">
//       <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 py-6 space-y-5">
//         <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
//           <div className="flex items-start gap-4">
//             <button
//               onClick={() => navigate(-1)}
//               className="mt-1 text-slate-800 hover:text-primary-color"
//             >
//               <ArrowBackIcon />
//             </button>

//             <div>
//               <h1 className="text-2xl font-bold text-slate-950">
//                 Order #{currentOrder?.id || orderId}
//               </h1>
//               <p className="text-sm text-slate-700 mt-1">
//                 Placed on {placedDate}
//               </p>
//             </div>
//           </div>

//           <div className="flex flex-col sm:flex-row gap-3">
//             <Tooltip title={cancelTooltipMessage} arrow disableHoverListener={!isShippedOrDelivered}>
//               <span>
//                 <Button
//                   disabled={isCancelled || isShippedOrDelivered}
//                   onClick={() => {
//                     const confirmed = window.confirm(
//                       "Are you sure you want to cancel the order?"
//                     );
//                     if (confirmed) {
//                       handleCancelOrder();
//                     }
//                   }}
//                   variant="outlined"
//                   color="error"
//                   sx={{
//                     px: 3,
//                     py: 1.2,
//                     borderColor: "var(--primary-color)",
//                     color: "var(--primary-color)",
//                     fontWeight: 600,
//                     textTransform: "none",
//                     "&:hover": {
//                       borderColor: "var(--primary-color)",
//                       backgroundColor: "rgba(233, 30, 99, 0.04)",
//                     },
//                   }}
//                 >
//                   {isCancelled ? "Order Canceled" : "Cancel Order"}
//                 </Button>
//               </span>
//             </Tooltip>

//             <Button
//               onClick={() => window.print()}
//               variant="outlined"
//               sx={{
//                 px: 3,
//                 py: 1.2,
//                 borderColor: "var(--primary-color)",
//                 color: "var(--primary-color)",
//                 fontWeight: 600,
//                 textTransform: "none",
//                 "&:hover": {
//                   borderColor: "var(--primary-color)",
//                   backgroundColor: "rgba(233, 30, 99, 0.04)",
//                 },
//               }}
//               endIcon={<FileDownloadOutlinedIcon />}
//             >
//               Download Invoice
//             </Button>
//           </div>
//         </div>

//         <section className="border rounded-lg bg-white p-5">
//           <div className="grid grid-cols-1 lg:grid-cols-[260px_280px_1fr] gap-5">
//             <div className="space-y-3">
//               <h2 className="font-bold text-lg">Order Status</h2>
//               <p
//                 className={`text-2xl font-bold ${isCancelled ? "text-red-600" : "text-green-600"
//                   }`}
//               >
//                 {currentOrder?.orderStatus || "Placed"}
//               </p>
//               <p className="text-sm text-slate-700">
//                 {isDelivered
//                   ? "Your order has been delivered."
//                   : isCancelled
//                     ? "Your order has been cancelled."
//                     : "Your order is being processed."}
//               </p>
//             </div>

//             <div className="lg:border-l lg:border-r lg:px-7 space-y-5">
//               <div className="flex items-center gap-2 text-sm">
//                 <span>Tracking ID:</span>
//                 <strong>{trackingId || "Not available"}</strong>

//                 {trackingId && (
//                   <ContentCopyIcon
//                     onClick={() => navigator.clipboard.writeText(trackingId)}
//                     className="cursor-pointer"
//                     fontSize="small"
//                   />
//                 )}
//               </div>

//               <Button
//                 variant="outlined"
//                 sx={{
//                   borderColor: "#e91e63",
//                   color: "#e91e63",
//                   fontWeight: 600,
//                   textTransform: "none",
//                 }}
//                 endIcon={<OpenInNewIcon />}
//               >
//                 Click here to track your order
//               </Button>
//             </div>

//             <div className="overflow-x-auto">
//               <OrderStepper orderStatus={currentOrder?.orderStatus} />
//             </div>
//           </div>
//         </section>

//         <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1.35fr)_minmax(360px,0.65fr)] gap-5">
//           <section className="border rounded-lg bg-white p-5">
//             <div className="flex items-center justify-between gap-4 mb-5">
//               <h2 className="font-bold text-lg">
//                 Order Summary ({orderItems.length} items)
//               </h2>
//             </div>

//             <div className="hidden lg:grid grid-cols-[minmax(0,1fr)_120px_120px] gap-4 border-b pb-3 text-sm font-semibold text-gray-700">
//               <p>Product</p>
//               <p className="text-center">Quantity</p>
//               <p className="text-right">Price</p>
//             </div>

//             <div className="space-y-4 lg:space-y-0 max-h-[520px] overflow-y-auto pr-2 custom-scrollbar">
//               {orderItems.map((item: any, index: number) => (
//                 <div key={item?.id || index}>
//                   <div className="lg:grid lg:grid-cols-[minmax(0,1fr)_120px_120px] lg:gap-4 lg:items-center py-4">
//                     <div className="flex gap-4">
//                       <img
//                         className="w-16 h-16 rounded-md object-cover border shrink-0"
//                         src={item?.product?.images?.[0]}
//                         alt={item?.product?.title || "Product"}
//                       />

//                       <div className="flex-1 min-w-0">
//                         <p className="font-medium text-slate-950">
//                           {item?.product?.title}
//                         </p>

//                         <p className="text-sm text-slate-700 mt-1">
//                           SKU: {item?.product?.sku || "N/A"}
//                         </p>

//                         <div className="text-sm text-slate-700 mt-1 flex flex-wrap gap-x-4 gap-y-1">
//                           <p>Colour: {item?.product?.color || "N/A"}</p>

//                           {item?.size && <p>Size: {item.size}</p>}

//                           <p className="lg:hidden">
//                             Quantity: {item?.quantity || 1}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="hidden lg:flex justify-center text-sm font-medium text-gray-900">
//                       {item?.quantity || 1}
//                     </div>

//                     <p className="font-bold whitespace-nowrap text-right mt-3 lg:mt-0">
//                       ₹{item?.sellingPrice || 0}.00
//                     </p>
//                   </div>

//                   {index !== orderItems.length - 1 && <Divider />}
//                 </div>
//               ))}
//             </div>

//             <Divider className="!my-5" />

//             <div className="space-y-3 max-w-md ml-auto">
//               <div className="flex justify-between text-sm">
//                 <span>Item Total ({orderItems.length} items)</span>
//                 <span>₹{itemTotal}.00</span>
//               </div>

//               <div className="flex justify-between text-sm">
//                 <span>Shipping Charges</span>
//                 <span className="text-green-600 font-medium">FREE</span>
//               </div>

//               {savedAmount > 0 && (
//                 <div className="flex justify-between text-sm">
//                   <span>Discount</span>
//                   <span className="text-green-600">- ₹{savedAmount}.00</span>
//                 </div>
//               )}

//               <Divider />

//               <div className="flex justify-between items-center">
//                 <span className="text-lg font-bold">Total Amount</span>
//                 <span className="text-2xl font-bold">₹{totalAmount}.00</span>
//               </div>

//               {savedAmount > 0 && (
//                 <p className="text-green-600 text-sm font-medium text-right">
//                   You Saved ₹{savedAmount}.00 on this order
//                 </p>
//               )}
//             </div>
//           </section>

//           <section className="border rounded-lg bg-white p-5 space-y-6">
//             <div>
//               <div className="flex items-center justify-between mb-6">
//                 <div className="flex items-center gap-2">
//                   <LocationOnIcon className="text-primary-color" />
//                   <h2 className="font-bold text-lg">Shipping Address</h2>
//                 </div>
//               </div>

//               <div className="text-sm sm:text-base space-y-2 text-slate-900">
//                 <p className="font-medium">{address?.name}</p>
//                 <p>
//                   {address?.address}, {address?.city} - {address?.pinCode},
//                 </p>
//                 <p>{address?.state}</p>
//                 <p>{address?.mobile}</p>
//               </div>
//             </div>

//             <Divider />

//             <div className="space-y-4">
//               <div>
//                 <h3 className="font-semibold text-gray-900 text-base">
//                   Rate & Review Product
//                 </h3>

//                 <p className="text-sm text-gray-500 mt-1">
//                   Share your experience with this product.
//                 </p>
//               </div>

//               <Tooltip
//                 title={
//                   !isDelivered
//                     ? "Review is only available once the order is delivered"
//                     : ""
//                 }
//                 arrow
//               >
//                 <span className="block">
//                   <Button
//                     fullWidth
//                     onClick={() =>
//                       navigate(`/reviews/${orderItem?.product?.id}/create`)
//                     }
//                     disabled={!isDelivered}
//                     variant="contained"
//                     sx={{
//                       py: 1.2,
//                       textTransform: "none",
//                       fontWeight: 600,
//                     }}
//                   >
//                     Write Review
//                   </Button>
//                 </span>
//               </Tooltip>
//             </div>
//           </section>
//         </div>
//       </div>
//     </Box>
//   );
// };

// export default OrderDetails;


// changes without invoice changes
// import { Box, Button, Divider, Tooltip } from "@mui/material";
// import React, { useEffect } from "react";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
// import OrderStepper from "./OrderStepper";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import {
//   cancelOrder,
//   fetchOrderById,
//   fetchOrderItemById,
// } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { useNavigate, useParams } from "react-router-dom";

// const themeButtonSx = {
//   px: 3,
//   py: 1.2,
//   borderRadius: "0.5rem",
//   borderColor: "var(--primary-color)",
//   color: "var(--primary-color)",
//   fontWeight: 600,
//   textTransform: "none",
//   "&:hover": {
//     borderColor: "var(--primary-color)",
//     backgroundColor: "#f3f4f6",
//   },
// };

// const OrderDetails = () => {
//   const dispatch = useAppDispatch();
//   const { auth, orders } = useAppSelector((store) => store);
//   const { orderItemId, orderId } = useParams();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (orderItemId) {
//       dispatch(
//         fetchOrderItemById({
//           orderItemId: Number(orderItemId),
//           jwt: localStorage.getItem("jwt") || "",
//         })
//       );
//     }

//     if (orderId) {
//       dispatch(
//         fetchOrderById({
//           orderId: Number(orderId),
//           jwt: localStorage.getItem("jwt") || "",
//         })
//       );
//     }
//   }, [auth.jwt, dispatch, orderId, orderItemId]);

//   if (!orders.orders || !orders.orderItem) {
//     return (
//       <div className="h-[80vh] flex justify-center items-center">
//         No order found
//       </div>
//     );
//   }

//   const currentOrder = orders.currentOrder;
//   const orderItem = orders.orderItem;

//   const handleCancelOrder = () => {
//     if (orderId) {
//       dispatch(cancelOrder(orderId));
//     }
//   };

//   const isDelivered = currentOrder?.orderStatus === "DELIVERED";
//   const isShipped = currentOrder?.orderStatus === "SHIPPED";
//   const isShippedOrDelivered = ["SHIPPED", "DELIVERED"].includes(
//     currentOrder?.orderStatus || ""
//   );
//   const isCancelled = currentOrder?.orderStatus === "CANCELLED";

//   const product = orderItem?.product;
//   const address = currentOrder?.shippingAddress;

//   const trackingId =
//     currentOrder?.trackingId || currentOrder?.trackingNumber || "";

//   const itemPrice = orderItem?.sellingPrice || 0;
//   const mrpPrice = orderItem?.mrpPrice || 0;
//   const savedAmount = Math.max(mrpPrice - itemPrice, 0);

//   const orderItems =
//     currentOrder?.orderItems && currentOrder.orderItems.length > 0
//       ? currentOrder.orderItems
//       : [orderItem];

//   const itemTotal = orderItems.reduce(
//     (total: number, item: any) =>
//       total + (item?.sellingPrice || 0) * (item?.quantity || 1),
//     0
//   );

//   const totalAmount =
//     currentOrder?.totalSellingPrice ||
//     currentOrder?.totalMrpPrice ||
//     itemTotal;

//   const placedDate = currentOrder?.orderDate
//     ? new Date(currentOrder.orderDate).toLocaleString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     })
//     : "Not available";

//   const cancelTooltipMessage = isShipped
//     ? "This order cannot be cancelled as it has already been shipped. If you received a damaged or incorrect item, you may request a replacement."
//     : isDelivered
//       ? "This order cannot be cancelled as it has already been delivered."
//       : "";

//   return (
//     <Box className="w-full">
//       <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 py-6 space-y-5">
//         <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
//           <div className="flex items-start gap-4">
//             <button
//               onClick={() => navigate(-1)}
//               className="mt-1 text-slate-800 hover:text-primary-color"
//             >
//               <ArrowBackIcon />
//             </button>

//             <div>
//               <h1 className="text-2xl font-bold text-slate-950">
//                 Order #OD102694500000{currentOrder?.id || orderId}
//               </h1>
//               <p className="text-sm text-slate-700 mt-1">
//                 Placed on {placedDate}
//               </p>
//             </div>
//           </div>

//           <div className="flex flex-col sm:flex-row gap-3">
//             <Tooltip
//               title={cancelTooltipMessage}
//               arrow
//               disableHoverListener={!isShippedOrDelivered}
//             >
//               <span>
//                 <Button
//                   disabled={isCancelled || isShippedOrDelivered}
//                   onClick={() => {
//                     const confirmed = window.confirm(
//                       "Are you sure you want to cancel the order?"
//                     );
//                     if (confirmed) {
//                       handleCancelOrder();
//                     }
//                   }}
//                   variant="outlined"
//                   color="error"
//                   sx={{
//                     px: 3,
//                     py: 1.2,
//                     borderRadius: "0.5rem",
//                     fontWeight: 600,
//                     textTransform: "none",
//                   }}
//                 >
//                   {isCancelled ? "Order Canceled" : "Cancel Order"}
//                 </Button>
//               </span>
//             </Tooltip>

//             <Button
//               onClick={() => window.print()}
//               variant="outlined"
//               sx={themeButtonSx}
//               endIcon={<FileDownloadOutlinedIcon />}
//             >
//               Download Invoice
//             </Button>
//           </div>
//         </div>

//         <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
//           <div className="grid grid-cols-1 lg:grid-cols-[260px_280px_1fr] gap-5">
//             <div className="space-y-3">
//               <h2 className="font-bold text-lg text-gray-900">Order Status</h2>
//               <p
//                 className={`text-2xl font-bold ${isCancelled ? "text-red-600" : "text-green-600"
//                   }`}
//               >
//                 {currentOrder?.orderStatus || "Placed"}
//               </p>
//               <p className="text-sm text-gray-600">
//                 {isDelivered
//                   ? "Your order has been delivered."
//                   : isCancelled
//                     ? "Your order has been cancelled."
//                     : "Your order is being processed."}
//               </p>
//             </div>

//             <div className="lg:border-l lg:border-r lg:px-7 space-y-5">
//               <div className="space-y-3">
//                 {/* <div className="flex items-start gap-2 text-sm">
//                   <span className="whitespace-nowrap text-gray-700">
//                     Tracking ID:
//                   </span>

//                   {isShippedOrDelivered ? (
//                     <div className="flex items-center gap-2">
//                       <strong>{trackingId || "Not available"}</strong>

//                       {trackingId && (
//                         <ContentCopyIcon
//                           onClick={() =>
//                             navigator.clipboard.writeText(trackingId)
//                           }
//                           className="cursor-pointer"
//                           fontSize="small"
//                         />
//                       )}
//                     </div>
//                   ) : (
//                     <p className="text-red-500">
//                       Tracking details will be available once the order is
//                       shipped.
//                     </p>
//                   )}
//                 </div>

//                 <Button
//                   variant="outlined"
//                   disabled={!isShippedOrDelivered}
//                   sx={themeButtonSx}
//                   endIcon={<OpenInNewIcon />}
//                 >
//                   Click here to track your order
//                 </Button> */}
//               </div>
//             </div>

//             <div className="overflow-x-auto">
//               <OrderStepper orderStatus={currentOrder?.orderStatus} />
//             </div>
//           </div>
//         </section>

//         <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1.35fr)_minmax(360px,0.65fr)] gap-5">
//           <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
//             <div className="flex items-center justify-between gap-4 mb-5">
//               <h2 className="font-bold text-lg text-gray-900">
//                 Order Summary ({orderItems.length} items)
//               </h2>
//             </div>

//             <div className="hidden lg:grid grid-cols-[minmax(0,1fr)_120px_120px] gap-4 border-b border-gray-200 pb-3 text-sm font-semibold text-gray-700">
//               <p>Product</p>
//               <p className="text-center">Quantity</p>
//               <p className="text-right">Price</p>
//             </div>

//             <div className="space-y-4 lg:space-y-0 max-h-[520px] overflow-y-auto pr-2 custom-scrollbar">
//               {orderItems.map((item: any, index: number) => (
//                 <div key={item?.id || index}>
//                   <div className="lg:grid lg:grid-cols-[minmax(0,1fr)_120px_120px] lg:gap-4 lg:items-center py-4">
//                     <div className="flex gap-4">
//                       <img
//                         className="w-16 h-16 rounded-xl object-cover border border-gray-200 shrink-0"
//                         src={item?.product?.images?.[0]}
//                         alt={item?.product?.title || "Product"}
//                       />

//                       <div className="flex-1 min-w-0">
//                         <p className="font-medium text-gray-900">
//                           {item?.product?.title}
//                         </p>
//                         <div className="text-sm text-gray-600 mt-1 flex flex-wrap gap-x-4 gap-y-1">
//                           <p>Colour: {item?.product?.color || "N/A"}</p>

//                           {item?.size && <p>Size: {item.size}</p>}

//                           <p className="lg:hidden">
//                             Quantity: {item?.quantity || 1}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="hidden lg:flex justify-center text-sm font-medium text-gray-900">
//                       {item?.quantity || 1}
//                     </div>

//                     <p className="font-bold whitespace-nowrap text-right mt-3 lg:mt-0">
//                       ₹{item?.sellingPrice || 0}.00
//                     </p>
//                   </div>

//                   {index !== orderItems.length - 1 && <Divider />}
//                 </div>
//               ))}
//             </div>

//             <Divider className="!my-5" />

//             <div className="space-y-3 max-w-md ml-auto">
//               <div className="flex justify-between text-sm">
//                 <span>Item Total ({orderItems.length} items)</span>
//                 <span>₹{itemTotal}.00</span>
//               </div>

//               <div className="flex justify-between text-sm">
//                 <span>Shipping Charges</span>
//                 <span className="text-green-600 font-medium">FREE</span>
//               </div>

//               {savedAmount > 0 && (
//                 <div className="flex justify-between text-sm">
//                   <span>Discount</span>
//                   <span className="text-green-600">- ₹{savedAmount}.00</span>
//                 </div>
//               )}

//               <Divider />

//               <div className="flex justify-between items-center">
//                 <span className="text-lg font-bold">Total Amount</span>
//                 <span className="text-2xl font-bold">₹{totalAmount}.00</span>
//               </div>

//               {savedAmount > 0 && (
//                 <p className="text-green-600 text-sm font-medium text-right">
//                   You Saved ₹{savedAmount}.00 on this order
//                 </p>
//               )}
//             </div>
//           </section>

//           <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 space-y-6">
//             <div>
//               <div className="flex items-center justify-between mb-6">
//                 <div className="flex items-center gap-2">
//                   <LocationOnIcon className="text-primary-color" />
//                   <h2 className="font-bold text-lg text-gray-900">
//                     Shipping Address
//                   </h2>
//                 </div>
//               </div>

//               <div className="text-sm sm:text-base space-y-2 text-gray-900">
//                 <p className="font-medium">{address?.name}</p>
//                 <p>
//                   {address?.address}, {address?.city} - {address?.pinCode},
//                 </p>
//                 <p>{address?.state}</p>
//                 <p>{address?.mobile}</p>
//               </div>
//             </div>

//             <Divider />

//             <div className="space-y-4">
//               <div>
//                 <h3 className="font-semibold text-gray-900 text-base">
//                   Rate & Review Product
//                 </h3>

//                 <p className="text-sm text-gray-500 mt-1">
//                   Share your experience with this product.
//                 </p>
//               </div>

//               <Tooltip
//                 title={
//                   !isDelivered
//                     ? "Review is only available once the order is delivered"
//                     : ""
//                 }
//                 arrow
//               >
//                 <span className="block">
//                   <Button
//                     fullWidth
//                     onClick={() =>
//                       navigate(`/reviews/${orderItem?.product?.id}/create`)
//                     }
//                     disabled={!isDelivered}
//                     variant="contained"
//                     sx={{
//                       py: 1.2,
//                       borderRadius: "0.5rem",
//                       textTransform: "none",
//                       fontWeight: 600,
//                     }}
//                   >
//                     Write Review
//                   </Button>
//                 </span>
//               </Tooltip>
//             </div>

//             <Divider />

//             <div className="space-y-3">
//               <div>
//                 <h3 className="font-semibold text-gray-900 text-base">
//                   Need Help?
//                 </h3>

//                 <p className="text-sm text-gray-500 mt-1">
//                   Facing an issue with this order? Contact us for help.
//                 </p>
//               </div>

//               <Button
//                 fullWidth
//                 onClick={() => navigate("/contact")}
//                 variant="outlined"
//                 sx={{
//                   ...themeButtonSx,
//                   width: "100%",
//                 }}
//               >
//                 Contact Us
//               </Button>
//             </div>
//           </section>
//         </div>
//       </div>
//     </Box>
//   );
// };

// export default OrderDetails;


// changes with invoice changes
import { Box, Button, Divider, Tooltip } from "@mui/material";
import React, { useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import OrderStepper from "./OrderStepper";
import { trackEvent } from "../../../util/analytics";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import {
  cancelOrder,
  fetchOrderById,
  fetchOrderItemById,
} from "../../../Redux Toolkit/Customer/OrderSlice";
import { useNavigate, useParams } from "react-router-dom";

const themeButtonSx = {
  px: 3,
  py: 1.2,
  borderRadius: "0.5rem",
  borderColor: "var(--primary-color)",
  color: "var(--primary-color)",
  fontWeight: 600,
  textTransform: "none",
  "&:hover": {
    borderColor: "var(--primary-color)",
    backgroundColor: "#f3f4f6",
  },
};

const OrderDetails = () => {
  const dispatch = useAppDispatch();
  const { auth, orders } = useAppSelector((store) => store);
  const { orderItemId, orderId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (orderItemId) {
      dispatch(
        fetchOrderItemById({
          orderItemId: Number(orderItemId),
          jwt: localStorage.getItem("jwt") || "",
        })
      );
    }

    if (orderId) {
      dispatch(
        fetchOrderById({
          orderId: Number(orderId),
          jwt: localStorage.getItem("jwt") || "",
        })
      );
    }
  }, [auth.jwt, dispatch, orderId, orderItemId]);

  if (!orders.orders || !orders.orderItem) {
    return (
      <div className="h-[80vh] flex justify-center items-center">
        No order found
      </div>
    );
  }

  const currentOrder = orders.currentOrder;
  const orderItem = orders.orderItem;
  const address = currentOrder?.shippingAddress;

  // const handleCancelOrder = () => {
  //   if (orderId) {
  //     dispatch(cancelOrder(orderId));
  //   }
  // };

  const handleCancelOrder = () => {
    if (orderId) {
      (dispatch as any)(cancelOrder(orderId))
        .unwrap()
        .then((res: any) => {
          try {
            trackEvent("ORDER_CANCELLED", {
              orderId: Number(orderId),
              page: window.location.pathname,
              metadata: JSON.stringify({
                orderStatus: res?.orderStatus || "CANCELLED",
              }),
            });
          } catch (err) {
            console.log("ORDER_CANCELLED tracking failed:", err);
          }
        })
        .catch((err: any) => {
          console.log("Cancel order failed:", err);
        });
    }
  };

  const isDelivered = currentOrder?.orderStatus === "DELIVERED";
  const isShipped = currentOrder?.orderStatus === "SHIPPED";
  const isShippedOrDelivered = ["SHIPPED", "DELIVERED"].includes(
    currentOrder?.orderStatus || ""
  );
  const isCancelled = currentOrder?.orderStatus === "CANCELLED";

  const orderItems =
    currentOrder?.orderItems && currentOrder.orderItems.length > 0
      ? currentOrder.orderItems
      : [orderItem];

  const itemTotal = orderItems.reduce(
    (total: number, item: any) =>
      total + (item?.sellingPrice || 0) * (item?.quantity || 1),
    0
  );

  const mrpTotal = orderItems.reduce(
    (total: number, item: any) =>
      total +
      (item?.mrpPrice || item?.sellingPrice || 0) * (item?.quantity || 1),
    0
  );

  const savedAmount = Math.max(mrpTotal - itemTotal, 0);

  const totalAmount =
    currentOrder?.totalSellingPrice ||
    currentOrder?.totalMrpPrice ||
    itemTotal;

  const placedDate = currentOrder?.orderDate
    ? new Date(currentOrder.orderDate).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    : "Not available";

  const cancelTooltipMessage = isShipped
    ? "This order cannot be cancelled as it has already been shipped. If you received a damaged or incorrect item, you may request a replacement."
    : isDelivered
      ? "This order cannot be cancelled as it has already been delivered."
      : "";

  const handleDownloadInvoice = () => {
    const invoiceWindow = window.open("", "_blank");

    if (!invoiceWindow) return;

    const logoUrl = `${window.location.origin}/logo.png`;

    const invoiceRows = orderItems
      .map((item: any, index: number) => {
        const quantity = item?.quantity || 1;
        const price = item?.sellingPrice || 0;
        const subtotal = price * quantity;
        const productImage = item?.product?.images?.[0] || "";

        return `
          <tr>
            <td>${index + 1}</td>
            <td>
              <div class="product-cell">
                ${productImage
            ? `<img class="product-img" src="${productImage}" alt="Product" />`
            : ""
          }
                <div>
                  <div class="product-title">
                    ${item?.product?.title || "Product"}
                  </div>
                  <div class="product-meta">
                    Colour: ${item?.product?.color || "N/A"}
                  </div>
                  ${item?.size
            ? `<div class="product-meta">Size: ${item.size}</div>`
            : ""
          }
                </div>
              </div>
            </td>
            <td class="center">${quantity}</td>
            <td class="right">Rs. ${price}.00</td>
            <td class="right bold">Rs. ${subtotal}.00</td>
          </tr>
        `;
      })
      .join("");

    invoiceWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Invoice - Order #OD102694500000${currentOrder?.id || orderId
      }</title>

          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet">

          <style>
            * {
              box-sizing: border-box;
            }

            body {
              margin: 0;
              padding: 40px;
              background: #f9fafb;
              color: #111827;
              font-family: 'Poppins', Arial, sans-serif;
            }

            .invoice-container {
              max-width: 1100px;
              margin: auto;
              background: #ffffff;
              border-radius: 20px;
              overflow: hidden;
              box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);
            }

            .top-bar {
              height: 8px;
              background: linear-gradient(90deg, #7c3aed, #ec4899);
            }

            .header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              gap: 24px;
              padding: 32px;
              border-bottom: 1px solid #e5e7eb;
            }

            .logo-section {
              display: flex;
              align-items: center;
              gap: 16px;
            }

            .logo {
              width: 74px;
              height: 74px;
              object-fit: contain;
              border-radius: 14px;
              border: 1px solid #f3f4f6;
            }

            .brand-name {
              font-size: 30px;
              font-weight: 700;
              color: #111827;
            }

            .brand-subtitle {
              color: #6b7280;
              margin-top: 4px;
              font-size: 14px;
            }

            .invoice-title {
              text-align: right;
            }

            .invoice-title h1 {
              margin: 0;
              font-size: 34px;
              color: #7c3aed;
              letter-spacing: 1px;
            }

            .invoice-title p {
              margin: 8px 0;
              color: #6b7280;
              font-size: 14px;
            }

            .status-badge {
              display: inline-block;
              margin-top: 8px;
              background: ${isCancelled ? "#fee2e2" : isDelivered ? "#dcfce7" : "#fef3c7"
      };
              color: ${isCancelled ? "#991b1b" : isDelivered ? "#166534" : "#92400e"
      };
              padding: 8px 16px;
              border-radius: 999px;
              font-size: 13px;
              font-weight: 600;
            }

            .section {
              padding: 32px;
            }

            .section-title {
              font-size: 20px;
              font-weight: 600;
              margin-bottom: 18px;
              color: #111827;
            }

            .address-box {
              background: #f9fafb;
              padding: 20px;
              border-radius: 14px;
              line-height: 1.8;
              border: 1px solid #e5e7eb;
              font-size: 14px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 16px;
            }

            thead {
              background: #f3f4f6;
            }

            th {
              padding: 16px;
              text-align: left;
              font-size: 14px;
              color: #374151;
              font-weight: 600;
            }

            td {
              padding: 18px 16px;
              border-bottom: 1px solid #f1f5f9;
              font-size: 14px;
              vertical-align: middle;
            }

            .product-cell {
              display: flex;
              align-items: center;
              gap: 12px;
            }

            .product-img {
              width: 60px;
              height: 60px;
              object-fit: cover;
              border-radius: 10px;
              border: 1px solid #e5e7eb;
            }

            .product-title {
              font-weight: 600;
              color: #111827;
            }

            .product-meta {
              font-size: 13px;
              color: #6b7280;
              margin-top: 4px;
            }

            .center {
              text-align: center;
            }

            .right {
              text-align: right;
            }

            .bold {
              font-weight: 600;
            }

            .summary {
              width: 390px;
              margin-left: auto;
              margin-top: 28px;
              background: #f9fafb;
              border-radius: 16px;
              padding: 24px;
              border: 1px solid #e5e7eb;
            }

            .summary-row {
              display: flex;
              justify-content: space-between;
              padding: 10px 0;
              font-size: 15px;
            }

            .free {
              color: #059669;
              font-weight: 600;
            }

            .discount {
              color: #059669;
            }

            .summary-total {
              margin-top: 12px;
              padding-top: 16px;
              border-top: 2px dashed #d1d5db;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }

            .summary-total span:first-child {
              font-size: 20px;
              font-weight: 700;
            }

            .summary-total span:last-child {
              font-size: 28px;
              font-weight: 700;
              color: #7c3aed;
            }

            .saved-text {
              color: #059669;
              font-weight: 600;
              margin-top: 12px;
              text-align: right;
            }

            .print-btn {
              margin-top: 26px;
              background: #7c3aed;
              color: #ffffff;
              border: none;
              padding: 14px 28px;
              border-radius: 12px;
              font-size: 15px;
              font-weight: 600;
              cursor: pointer;
            }

            .footer {
              padding: 28px 32px;
              background: #111827;
              color: white;
              text-align: center;
              font-size: 14px;
            }

            @media print {
              body {
                background: #ffffff;
                padding: 0;
              }

              .invoice-container {
                box-shadow: none;
                border-radius: 0;
              }

              .print-btn {
                display: none;
              }
            }
          </style>
        </head>

        <body>
          <div class="invoice-container">
            <div class="top-bar"></div>

            <div class="header">
              <div class="logo-section">
                <img class="logo" src="${logoUrl}" alt="Priya Beads Logo" />
                <div>
                  <div class="brand-name">Priya Beads</div>
                  <div class="brand-subtitle">
                    Premium Jewellery Collection
                  </div>
                </div>
              </div>

              <div class="invoice-title">
                <h1>INVOICE</h1>
                <p>Order #OD102694500000${currentOrder?.id || orderId}</p>
                <p>Placed on ${placedDate}</p>
                <div class="status-badge">
                  ${currentOrder?.orderStatus || "PLACED"}
                </div>
              </div>
            </div>

            <div class="section">
              <div class="section-title">Shipping Address</div>

              <div class="address-box">
                <strong>${address?.name || ""}</strong><br />
                ${address?.address || ""}, ${address?.city || ""} - ${address?.pinCode || ""
      }<br />
                ${address?.state || ""}<br />
                Mobile: ${address?.mobile || ""}
              </div>
            </div>

            <div class="section">
              <div class="section-title">
                Order Summary (${orderItems.length} items)
              </div>

              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Product</th>
                    <th class="center">Qty</th>
                    <th class="right">Price</th>
                    <th class="right">Subtotal</th>
                  </tr>
                </thead>

                <tbody>
                  ${invoiceRows}
                </tbody>
              </table>

              <div class="summary">
                <div class="summary-row">
                  <span>Item Total</span>
                  <span>Rs. ${itemTotal}.00</span>
                </div>

                <div class="summary-row">
                  <span>Shipping Charges</span>
                  <span class="free">FREE</span>
                </div>

                ${savedAmount > 0
        ? `
                    <div class="summary-row">
                      <span>Discount</span>
                      <span class="discount">- Rs. ${savedAmount}.00</span>
                    </div>
                  `
        : ""
      }

                <div class="summary-total">
                  <span>Total Amount</span>
                  <span>Rs. ${totalAmount}.00</span>
                </div>

                ${savedAmount > 0
        ? `
                    <div class="saved-text">
                      You Saved Rs. ${savedAmount}.00
                    </div>
                  `
        : ""
      }
              </div>

              <button class="print-btn" onclick="window.print()">
                Print / Download Invoice
              </button>
            </div>

            <div class="footer">
              Thank you for shopping with Priya Beads
            </div>
          </div>
        </body>
      </html>
    `);

    invoiceWindow.document.close();
    invoiceWindow.focus();
  };

  return (
    <Box className="w-full">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10 py-6 space-y-5">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div className="flex items-start gap-4">
            <button
              onClick={() => navigate(-1)}
              className="mt-1 text-slate-800 hover:text-primary-color"
            >
              <ArrowBackIcon />
            </button>

            <div>
              <h1 className="text-2xl font-bold text-slate-950">
                Order #OD102694500000{currentOrder?.id || orderId}
              </h1>
              <p className="text-sm text-slate-700 mt-1">
                Placed on {placedDate}
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Tooltip
              title={cancelTooltipMessage}
              arrow
              disableHoverListener={!isShippedOrDelivered}
            >
              <span>
                <Button
                  disabled={isCancelled || isShippedOrDelivered}
                  onClick={() => {
                    const confirmed = window.confirm(
                      "Are you sure you want to cancel the order?"
                    );
                    if (confirmed) {
                      handleCancelOrder();
                    }
                  }}
                  variant="outlined"
                  color="error"
                  sx={{
                    px: 3,
                    py: 1.2,
                    borderRadius: "0.5rem",
                    fontWeight: 600,
                    textTransform: "none",
                  }}
                >
                  {isCancelled ? "Order Canceled" : "Cancel Order"}
                </Button>
              </span>
            </Tooltip>

            <Button
              onClick={handleDownloadInvoice}
              variant="outlined"
              sx={themeButtonSx}
              endIcon={<FileDownloadOutlinedIcon />}
            >
              Download Invoice
            </Button>
          </div>
        </div>

        <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
          <div className="grid grid-cols-1 lg:grid-cols-[260px_280px_1fr] gap-5">
            <div className="space-y-3">
              <h2 className="font-bold text-lg text-gray-900">Order Status</h2>
              <p
                className={`text-2xl font-bold ${isCancelled ? "text-red-600" : "text-green-600"
                  }`}
              >
                {currentOrder?.orderStatus || "Placed"}
              </p>
              <p className="text-sm text-gray-600">
                {isDelivered
                  ? "Your order has been delivered."
                  : isCancelled
                    ? "Your order has been cancelled."
                    : "Your order is being processed."}
              </p>
            </div>

            <div className="lg:border-l lg:border-r lg:px-7 space-y-5">
              <div className="space-y-3">
                {/* 
                  TRACKING DETAILS START

                  To show tracking details later, uncomment this block and also add these imports:
                  import ContentCopyIcon from "@mui/icons-material/ContentCopy";
                  import OpenInNewIcon from "@mui/icons-material/OpenInNew";

                  const trackingId =
                    currentOrder?.trackingId || currentOrder?.trackingNumber || "";
                */}

                {/*
                <div className="flex items-start gap-2 text-sm">
                  <span className="whitespace-nowrap text-gray-700">
                    Tracking ID:
                  </span>

                  {isShippedOrDelivered ? (
                    <div className="flex items-center gap-2">
                      <strong>{trackingId || "Not available"}</strong>

                      {trackingId && (
                        <ContentCopyIcon
                          onClick={() =>
                            navigator.clipboard.writeText(trackingId)
                          }
                          className="cursor-pointer"
                          fontSize="small"
                        />
                      )}
                    </div>
                  ) : (
                    <p className="text-red-500">
                      Tracking details will be available once the order is shipped.
                    </p>
                  )}
                </div>

                <Button
                  variant="outlined"
                  disabled={!isShippedOrDelivered}
                  sx={themeButtonSx}
                  endIcon={<OpenInNewIcon />}
                >
                  Click here to track your order
                </Button>
                */}

                {/* TRACKING DETAILS END */}
              </div>
            </div>

            <div className="overflow-x-auto">
              <OrderStepper orderStatus={currentOrder?.orderStatus} />
            </div>
          </div>
        </section>

        <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1.35fr)_minmax(360px,0.65fr)] gap-5">
          <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
            <div className="flex items-center justify-between gap-4 mb-5">
              <h2 className="font-bold text-lg text-gray-900">
                Order Summary ({orderItems.length} items)
              </h2>
            </div>

            <div className="hidden lg:grid grid-cols-[minmax(0,1fr)_120px_120px] gap-4 border-b border-gray-200 pb-3 text-sm font-semibold text-gray-700">
              <p>Product</p>
              <p className="text-center">Quantity</p>
              <p className="text-right">Price</p>
            </div>

            <div className="space-y-4 lg:space-y-0 max-h-[520px] overflow-y-auto pr-2 custom-scrollbar">
              {orderItems.map((item: any, index: number) => (
                <div key={item?.id || index}>
                  <div className="lg:grid lg:grid-cols-[minmax(0,1fr)_120px_120px] lg:gap-4 lg:items-center py-4">
                    <div className="flex gap-4">
                      <img
                        className="w-16 h-16 rounded-xl object-cover border border-gray-200 shrink-0"
                        src={item?.product?.images?.[0]}
                        alt={item?.product?.title || "Product"}
                      />

                      <div className="flex-1 min-w-0">
                        <p className="font-medium text-gray-900">
                          {item?.product?.title}
                        </p>

                        <div className="text-sm text-gray-600 mt-1 flex flex-wrap gap-x-4 gap-y-1">
                          <p>Colour: {item?.product?.color || "N/A"}</p>

                          {item?.size && <p>Size: {item.size}</p>}

                          <p className="lg:hidden">
                            Quantity: {item?.quantity || 1}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="hidden lg:flex justify-center text-sm font-medium text-gray-900">
                      {item?.quantity || 1}
                    </div>

                    <p className="font-bold whitespace-nowrap text-right mt-3 lg:mt-0">
                      ₹{item?.sellingPrice || 0}.00
                    </p>
                  </div>

                  {index !== orderItems.length - 1 && <Divider />}
                </div>
              ))}
            </div>

            <Divider className="!my-5" />

            <div className="space-y-3 max-w-md ml-auto">
              <div className="flex justify-between text-sm">
                <span>Item Total ({orderItems.length} items)</span>
                <span>₹{itemTotal}.00</span>
              </div>

              <div className="flex justify-between text-sm">
                <span>Shipping Charges</span>
                <span className="text-green-600 font-medium">FREE</span>
              </div>

              {savedAmount > 0 && (
                <div className="flex justify-between text-sm">
                  <span>Discount</span>
                  <span className="text-green-600">- ₹{savedAmount}.00</span>
                </div>
              )}

              <Divider />

              <div className="flex justify-between items-center">
                <span className="text-lg font-bold">Total Amount</span>
                <span className="text-2xl font-bold">₹{totalAmount}.00</span>
              </div>

              {savedAmount > 0 && (
                <p className="text-green-600 text-sm font-medium text-right">
                  You Saved ₹{savedAmount}.00 on this order
                </p>
              )}
            </div>
          </section>

          <section className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5 space-y-6">
            <div>
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-2">
                  <LocationOnIcon className="text-primary-color" />
                  <h2 className="font-bold text-lg text-gray-900">
                    Shipping Address
                  </h2>
                </div>
              </div>

              <div className="text-sm sm:text-base space-y-2 text-gray-900">
                <p className="font-medium">{address?.name}</p>
                <p>
                  {address?.address}, {address?.city} - {address?.pinCode},
                </p>
                <p>{address?.state}</p>
                <p>{address?.mobile}</p>
              </div>
            </div>

            <Divider />

            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-gray-900 text-base">
                  Rate & Review Product
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Share your experience with this product.
                </p>
              </div>

              <Tooltip
                title={
                  !isDelivered
                    ? "Review is only available once the order is delivered"
                    : ""
                }
                arrow
              >
                <span className="block">
                  <Button
                    fullWidth
                    onClick={() =>
                      navigate(`/reviews/${orderItem?.product?.id}/create`)
                    }
                    disabled={!isDelivered}
                    variant="contained"
                    sx={{
                      py: 1.2,
                      borderRadius: "0.5rem",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Write Review
                  </Button>
                </span>
              </Tooltip>
            </div>

            <Divider />

            <div className="space-y-3">
              <div>
                <h3 className="font-semibold text-gray-900 text-base">
                  Need Help?
                </h3>

                <p className="text-sm text-gray-500 mt-1">
                  Facing an issue with this order? Contact us for help.
                </p>
              </div>

              <Button
                fullWidth
                onClick={() => navigate("/contact")}
                variant="outlined"
                sx={{
                  ...themeButtonSx,
                  width: "100%",
                }}
              >
                Contact Us
              </Button>
            </div>
          </section>
        </div>
      </div>
    </Box>
  );
};

export default OrderDetails;